import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from '../components/LandingPage.vue';
import AboutPage from '../components/AboutPage.vue';
import LoginPage from '../components/LoginPage.vue';
import SignUpPage from '../components/SignUpPage.vue';
import PostcardCreation from '../components/PostcardCreation.vue';
import MyProfilePage from '../components/MyProfilePage.vue';
import PrivacyPolicyComponent from '../components/PrivacyPolicy.vue';
import TermsOfServiceComponent from "../components/TermsOfService.vue";
import FAQComponent from '../components/FAQPage.vue';
import SuccessPage from "../components/SuccessPage.vue";
import FailurePage from "../components/FailurePage.vue";
import CheckoutPage from "../components/CheckoutPage.vue";
import LearnMorePage from "../components/LearnMore.vue";
import ContactUsPage from "../components/ContactUs.vue";
import WhatsThisPage from "../components/WhatsThis.vue"
import MyPeoplePage from '../components/MyPeoplePage.vue'
import GiftsInboxPage from '../components/GiftsInboxPage.vue'
import GiftReviewPage from '../components/GiftReviewPage.vue'
import MembershipPage from '../components/MembershipPage.vue'
import AssistantPage from '../components/AssistantPage.vue'
import EnvelopePage from '../components/EnvelopePage.vue'
import PersonPage from '../components/PersonPage.vue'
import RecipientPage from '../components/RecipientPage.vue'
import AgentCheckoutPage from '../components/AgentCheckoutPage.vue'
import NotFound from '../components/NotFound.vue'

import { auth,analytics } from '@/firebase';
import {onAuthStateChanged} from "firebase/auth";
import { logEvent } from "firebase/analytics";

const routes = [
    // Public, indexable marketing routes carry unique title + description so each
    // page gets its own metadata (applied at runtime by @vueuse/head in App.vue)
    // instead of sharing one static title, and baked into each route's served HTML
    // by the build-time prerender in vue.config.js.
    { path: '/', component: LandingPage, meta: { riso: true,
        title: 'Thinking of U | Send a Real Postcard to Someone You Miss',
        description: 'You pick who and the vibe. We write it, illustrate it, print it, and mail it — a one-of-a-kind postcard in their mailbox. No previews. No edits.' } },
    { path: '/about', component: AboutPage, meta: {
        title: 'About Thinking of U | Real Mail, Made for One Person',
        description: 'The story behind Thinking of U: a postcard you did not have to write, draw, address, or stamp — mailed to someone you care about.' } },
    { path: '/faq', component: FAQComponent, meta: {
        title: 'FAQ | Thinking of U',
        description: 'How it works, pricing, delivery times, privacy, and what happens if you do not love the surprise — answered.' } },
    { path: '/learn-more', component: LearnMorePage, meta: {
        title: 'How It Works | Thinking of U',
        description: 'How Thinking of U turns a few choices into a one-of-a-kind postcard, printed and mailed to someone you care about.' } },
    { path: '/contact-us', component: ContactUsPage, meta: {
        title: 'Contact Us | Thinking of U',
        description: 'Questions about a postcard, an order, or anything else? Get in touch with the Thinking of U team.' } },
    { path: '/whats-this', component: WhatsThisPage, meta: {
        title: 'What Is a Thinking of U Postcard?',
        description: 'Someone mailed you a one-of-a-kind postcard. Here is what it is — and how to send one back.' } },
    { path: '/create-postcard', component: PostcardCreation, meta: {
        title: 'Send a Postcard Online | Thinking of U',
        description: 'Choose a vibe and send a surprise postcard — printed and mailed for $5. No previews, no edits.' } },
    { path: '/privacy-policy', component: PrivacyPolicyComponent, meta: {
        title: 'Privacy Policy | Thinking of U',
        description: 'How Thinking of U collects, uses, and protects your information.' } },
    { path: '/terms-of-service', component: TermsOfServiceComponent, meta: {
        title: 'Terms of Service | Thinking of U',
        description: 'The terms that govern your use of Thinking of U.' } },

    // Private / transactional routes: noindex (also disallowed in robots.txt).
    { path: '/login', component: LoginPage, meta: { title: 'Log In | Thinking of U', noindex: true } },
    { path: '/signup', component: SignUpPage, meta: { title: 'Sign Up | Thinking of U', noindex: true } },
    { path: '/success', component: SuccessPage, meta: { title: 'Order Complete | Thinking of U', noindex: true } },
    { path: '/failure', component: FailurePage, meta: { title: 'Payment Issue | Thinking of U', noindex: true } },
    { path: '/checkout', component: CheckoutPage, meta: { title: 'Checkout | Thinking of U', noindex: true } },
    { path: '/profile', component: MyProfilePage, meta: { requiresAuth: true, noindex: true, title: 'My Profile | Thinking of U' } },
    { path: '/my-people', component: MyPeoplePage, meta: { requiresAuth: true, noindex: true, title: 'My People | Thinking of U' } },
    { path: '/people/:id', component: PersonPage, meta: { requiresAuth: true, noindex: true, riso: true, title: 'A Person | Thinking of U' } },
    { path: '/gifts', component: GiftsInboxPage, meta: { requiresAuth: true, noindex: true, title: 'Gift Ideas | Thinking of U' } },
    { path: '/gifts/:id', component: GiftReviewPage, meta: { requiresAuth: true, noindex: true, riso: true, title: 'Gift Review | Thinking of U' } },
    { path: '/membership', component: MembershipPage, meta: { requiresAuth: true, noindex: true, title: 'Membership | Thinking of U' } },
    { path: '/assistant/envelope', component: EnvelopePage, meta: { requiresAuth: true, noindex: true, riso: true, title: 'The Envelope | Thinking of U' } },
    { path: '/assistant', component: AssistantPage, meta: { requiresAuth: true, noindex: true, riso: true, title: 'The Desk | Thinking of U' } },
    // The recipient's page: reached from the link that arrives with what they
    // were sent. No account; the token in the URL is the credential.
    // `bare`: the person here is not a member and has no account; the shell
    // shows them the wordmark and nothing that belongs to the member.
    { path: '/mine/:token?', component: RecipientPage, meta: { noindex: true, secretPath: true, riso: true, bare: true, title: 'What Reaches You | Thinking of U' } },
    // The hosted checkout an assistant hands a person: the cart id is the credential.
    { path: '/agent-checkout/:cartId', component: AgentCheckoutPage, meta: { noindex: true, secretPath: true, title: 'Finish This Order | Thinking of U' } },

    // Catch-all: render a 404 page (noindex) instead of redirecting unknown URLs to
    // the home page. NOTE: Firebase rewrites all paths to index.html, so the HTTP
    // status is still 200 (soft-404) and the noindex only reaches Google's JS-render
    // pass; a true 404 status needs a hosting rule/prerender (deferred). The win is
    // no longer serving duplicate home-page content for every unknown URL.
    { path: '/:pathMatch(.*)*', component: NotFound, meta: { title: 'Page Not Found | Thinking of U', noindex: true } },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash, behavior: 'smooth' };
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    // Firebase auth listener to wait for auth state to settle
    const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe();  // Unsubscribe from the listener once we get the state
        // If the route requires auth and user is not authenticated, redirect to login
        if (requiresAuth && !user) {
            // Keep where they were going (e.g. the weekly question's answer link).
            next(to.fullPath && to.fullPath !== '/' ? { path: '/login', query: { redirect: to.fullPath } } : '/login');
        } else {
            next();  // Otherwise, proceed as normal
        }
    });
});
// A recipient's claim token is a bearer credential; it must never land in
// analytics. Log the route pattern, not the URL, for those pages.
const scrubPath = (route) => (route.matched.some((r) => r.meta && r.meta.secretPath) ? route.matched[route.matched.length - 1].path : route.fullPath);
router.afterEach((to, from) => {
    if (analytics) {
        const secret = to.matched.some((r) => r.meta && r.meta.secretPath);
        logEvent(analytics, 'page_view', {
            page_path: scrubPath(to),
            page_title: document.title,
            page_location: secret ? `${window.location.origin}${scrubPath(to)}` : window.location.href,
            previous_path: scrubPath(from)
        });
    }
});

export default router;
